import { render, staticRenderFns } from "./Capacidades.vue?vue&type=template&id=70141a26&scoped=true"
import script from "./Capacidades.vue?vue&type=script&lang=js"
export * from "./Capacidades.vue?vue&type=script&lang=js"
import style0 from "./Capacidades.vue?vue&type=style&index=0&id=70141a26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70141a26",
  null
  
)

export default component.exports